//TODO: consider delete this pipe and use TablefilterMultiplePipe if choosing to use Angular Material Sort Table for data sorting. 
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderFilterPipe'
})

export class OrderFilterPipe implements PipeTransform {
    transform(items: any[], filterValue: string, comparedProperty?:string, sortingOrder?:string) {

        let filterResult:any[] = [];
        let newResult = [];

        if(!items) return [];
        if(!filterValue) {
            if( comparedProperty && comparedProperty !== ''){
                return this.sorting(comparedProperty,sortingOrder,items);
            }else{
                return items;
            }
        };

        newResult =  items.filter( it => {
            if((it.orderNo+it.orderSuffix).trim().toLowerCase().includes(filterValue.trim().toLowerCase())){
                return it;
            } else if(it.resellerPO.toLowerCase().includes(filterValue.toLowerCase())){
                return it;
            }
        });

        if(this.checkingArr(filterResult) ){
            filterResult = filterResult.concat(newResult)
        }else if( newResult.length > 0){
            filterResult = newResult;
        }

        //-----------------------------Adding sorting here-----------------------------------
        this.sorting(comparedProperty,sortingOrder,filterResult);
        //-----------------------------Adding sorting here-----------------------------------
        
        if(filterResult.length > 0){
            return filterResult;
        }else{
            return [];
        }
    }

    checkingArr(array:any[]):boolean{
        if(typeof array != "undefined" && array != null
        ){
            if(array.length != null && array.length > 0){
                return true;
            }
            return false;
        }else{
            return false;
        }
    }

    sorting(comparedProperty:string | undefined,sortingOrder="string",filterResult:any[]){
        if(comparedProperty && sortingOrder){
            //sort by number
            if(comparedProperty === 'orderNo' || comparedProperty === 'totalEx'){
                if(sortingOrder === 'descending'){
                    filterResult.sort((a: any, b: any) => a[comparedProperty] - b[comparedProperty]);
                }else if(sortingOrder === 'ascending'){
                    filterResult.sort((a: any, b: any) => b[comparedProperty] - a[comparedProperty]);
                }
            }
            //sort by order date
            if(comparedProperty === 'dateOrdered' || comparedProperty === 'dateInvoiced'){
                if(sortingOrder === 'descending'){
                    filterResult.sort((a: any, b: any) => {
                        let x:any = `${a[comparedProperty].slice(6,10)}${a[comparedProperty].slice(3,5)}${a[comparedProperty].slice(0,2)}`;
                        let y:any = `${b[comparedProperty].slice(6,10)}${b[comparedProperty].slice(3,5)}${b[comparedProperty].slice(0,2)}`;
                        return (x - y);
                    });
                }else if(sortingOrder === 'ascending'){
                    filterResult.sort((a: any, b: any) => {
                        let x:any = `${a[comparedProperty].slice(6,10)}${a[comparedProperty].slice(3,5)}${a[comparedProperty].slice(0,2)}`;
                        let y:any = `${b[comparedProperty].slice(6,10)}${b[comparedProperty].slice(3,5)}${b[comparedProperty].slice(0,2)}`;
                        return (y - x);
                    });
                }
            }
            //sort by string
            if(comparedProperty === 'orderStatus' || comparedProperty === 'holdReasonDescription' || comparedProperty === 'resellerPO'){
                this.sortByString(comparedProperty,sortingOrder,filterResult);
            }
        }
        return filterResult;
    }

    sortByString(comparedProperty:string,sortingOrder:string,filterResult:any[]){
        if(sortingOrder === 'descending'){
            filterResult.sort(function(a, b){
                let x = a[comparedProperty].toLowerCase().trim();
                let y = b[comparedProperty].toLowerCase().trim();
                if (x < y) {return -1;}
                if (x > y) {return 1;}
                return 0;
            });
        }else if(sortingOrder === 'ascending'){
            filterResult.sort(function(a, b){
                let x = a[comparedProperty].toLowerCase().trim();
                let y = b[comparedProperty].toLowerCase().trim();
                if (x < y) {return -1;}
                if (x > y) {return 1;}
                return 0;
            });
            filterResult.reverse();
        }
    }

}